import { render, staticRenderFns } from "./PreviewWarnings.vue?vue&type=template&id=5a11437d&scoped=true"
import script from "./PreviewWarnings.vue?vue&type=script&lang=js"
export * from "./PreviewWarnings.vue?vue&type=script&lang=js"
import style0 from "./PreviewWarnings.vue?vue&type=style&index=0&id=5a11437d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a11437d",
  null
  
)

export default component.exports